import { renderInDocument } from '@spotahome/soyuz/client';

import GenericErrorPage from './main';

renderInDocument(GenericErrorPage);
